"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePollFromTemplate = exports.sendPollNotification = exports.createPollFromTemplate = exports.addPollCover = exports.vote = exports.deleteQuestionAttachment = exports.addQuestionAttachments = exports.deletePollQuestionItem = exports.updatePollQuestionItem = exports.addPollQuestionItem = exports.deletePollQuestion = exports.updatePollQuestion = exports.createPollQuestion = exports.deletePollAttachment = exports.addPollAttachments = exports.setPollStatus = exports.copyPoll = exports.deletePoll = exports.updatePoll = exports.createPoll = exports.updatePollDateFinished = void 0;
var updatePollDateFinished_1 = require("./updatePollDateFinished");
Object.defineProperty(exports, "updatePollDateFinished", {
  enumerable: true,
  get: function () {
    return __importDefault(updatePollDateFinished_1).default;
  }
});
var createPoll_1 = require("./createPoll");
Object.defineProperty(exports, "createPoll", {
  enumerable: true,
  get: function () {
    return __importDefault(createPoll_1).default;
  }
});
var updatePoll_1 = require("./updatePoll");
Object.defineProperty(exports, "updatePoll", {
  enumerable: true,
  get: function () {
    return __importDefault(updatePoll_1).default;
  }
});
var deletePoll_1 = require("./deletePoll");
Object.defineProperty(exports, "deletePoll", {
  enumerable: true,
  get: function () {
    return __importDefault(deletePoll_1).default;
  }
});
var copyPoll_1 = require("./copyPoll");
Object.defineProperty(exports, "copyPoll", {
  enumerable: true,
  get: function () {
    return __importDefault(copyPoll_1).default;
  }
});
var setPollStatus_1 = require("./setPollStatus");
Object.defineProperty(exports, "setPollStatus", {
  enumerable: true,
  get: function () {
    return __importDefault(setPollStatus_1).default;
  }
});
var addPollAttachments_1 = require("./addPollAttachments");
Object.defineProperty(exports, "addPollAttachments", {
  enumerable: true,
  get: function () {
    return __importDefault(addPollAttachments_1).default;
  }
});
var deletePollAttachment_1 = require("./deletePollAttachment");
Object.defineProperty(exports, "deletePollAttachment", {
  enumerable: true,
  get: function () {
    return __importDefault(deletePollAttachment_1).default;
  }
});
var createPollQuestion_1 = require("./createPollQuestion");
Object.defineProperty(exports, "createPollQuestion", {
  enumerable: true,
  get: function () {
    return __importDefault(createPollQuestion_1).default;
  }
});
var updatePollQuestion_1 = require("./updatePollQuestion");
Object.defineProperty(exports, "updatePollQuestion", {
  enumerable: true,
  get: function () {
    return __importDefault(updatePollQuestion_1).default;
  }
});
var deletePollQuestion_1 = require("./deletePollQuestion");
Object.defineProperty(exports, "deletePollQuestion", {
  enumerable: true,
  get: function () {
    return __importDefault(deletePollQuestion_1).default;
  }
});
var addPollQuestionItem_1 = require("./addPollQuestionItem");
Object.defineProperty(exports, "addPollQuestionItem", {
  enumerable: true,
  get: function () {
    return __importDefault(addPollQuestionItem_1).default;
  }
});
var updatePollQuestionItem_1 = require("./updatePollQuestionItem");
Object.defineProperty(exports, "updatePollQuestionItem", {
  enumerable: true,
  get: function () {
    return __importDefault(updatePollQuestionItem_1).default;
  }
});
var deletePollQuestionItem_1 = require("./deletePollQuestionItem");
Object.defineProperty(exports, "deletePollQuestionItem", {
  enumerable: true,
  get: function () {
    return __importDefault(deletePollQuestionItem_1).default;
  }
});
var addQuestionAttachments_1 = require("./addQuestionAttachments");
Object.defineProperty(exports, "addQuestionAttachments", {
  enumerable: true,
  get: function () {
    return __importDefault(addQuestionAttachments_1).default;
  }
});
var deleteQuestionAttachment_1 = require("./deleteQuestionAttachment");
Object.defineProperty(exports, "deleteQuestionAttachment", {
  enumerable: true,
  get: function () {
    return __importDefault(deleteQuestionAttachment_1).default;
  }
});
var vote_1 = require("./vote");
Object.defineProperty(exports, "vote", {
  enumerable: true,
  get: function () {
    return __importDefault(vote_1).default;
  }
});
var addPollCover_1 = require("./addPollCover");
Object.defineProperty(exports, "addPollCover", {
  enumerable: true,
  get: function () {
    return __importDefault(addPollCover_1).default;
  }
});
var createPollFromTemplate_1 = require("./createPollFromTemplate");
Object.defineProperty(exports, "createPollFromTemplate", {
  enumerable: true,
  get: function () {
    return __importDefault(createPollFromTemplate_1).default;
  }
});
var sendPollNotification_1 = require("./sendPollNotification");
Object.defineProperty(exports, "sendPollNotification", {
  enumerable: true,
  get: function () {
    return __importDefault(sendPollNotification_1).default;
  }
});
var updatePollFromTemplate_1 = require("./updatePollFromTemplate");
Object.defineProperty(exports, "updatePollFromTemplate", {
  enumerable: true,
  get: function () {
    return __importDefault(updatePollFromTemplate_1).default;
  }
});